import { apiAddress } from "../../config/server";

import { IGame } from "../../types/game/Game";
import { IGameConfigurationField } from "../../types/game/GameConfiguration";
import { ICascadedPayrate } from "../../types/payrates/PayRate";
import { ApiBase, GenericTransport } from "./baseApi";

export default class GameApi extends ApiBase {
  static GameApiBase = `${apiAddress}/api/game/`;

  static deleteGame(gameId: string) {
    return GameApi.post(`${GameApi.GameApiBase + gameId}/delete`).then(
      () => true,
    );
  }

  static updateGame(game: Partial<IGame>): Promise<GenericTransport<null>> {
    if (!game._id) throw new Error("Must pass an _id to updateGame function");
    return GameApi.post<null>(GameApi.GameApiBase + game._id, game).then(
      (resp) => resp.data, // resp.data already includes games array when server returns it
    );
  }

  static rosterGame(
    gameId: string,
    person: string,
    position: string,
    hasApprentice: boolean,
    shiftSessionId: string,
    loadings: Array<object>,
    startDate: string,
    venue: string
  ): Promise<GenericTransport<null>> {
    // roster/:game
    if (!person) throw new Error("No person");
    return GameApi.post<null>(
      `${this.GameApiBase}${gameId}/roster/${position}`,
      {
        allocation: { person, apprentice: hasApprentice },
        loadings,
        shiftSessionId,
        start: startDate,
        venue,
      },
    ).then((res) => {
      if (!res.data || !res.data.success) {
        throw new Error(
          res.data
            ? res.data.error
            : "Unknown error ocurred when rostering game",
        );
      }
      return res.data;
    });
  }

  static getEffectivePayrate(
    gameId: string,
    shiftSessionId?: string,
  ): Promise<GenericTransport<{ payrate: ICascadedPayrate | null; sources: { _id?: string; name?: string; associationId?: string }[] }>> {
    const query = this.prepareQueryParams({ shiftSessionId });
    return GameApi.get(`${GameApi.GameApiBase}${gameId}/payrate${query}`).then((resp) => resp.data);
  }

  static removeReferee(gameId: string, position: string, shiftSessionId: string, comment?: string) {
    const queryParams = this.prepareQueryParams({
      shiftSessionId,
      comment,
    });
    return GameApi.delete(
      `${this.GameApiBase}${gameId}/roster/${position}${queryParams}`,
    ).then((res) => res.data);
  }

  static addExtraOfficial(gameId: string, field: IGameConfigurationField, shiftId: string) {
    return GameApi.post<IGame>(
      `${this.GameApiBase}${gameId}/config?shiftId=${shiftId}`,
      field,
    ).then((res) => res.data.data);
  }

  static removeExtraOfficial(
    gameId: string,
    field: string,
    shiftSessionId: string,
  ) {
    return GameApi.delete<IGame>(
      `${this.GameApiBase}${gameId}/config/${field}?shiftSessionId=${shiftSessionId}`,
    ).then((res) => res.data.data);
  }
}
